module.exports = __webpack_public_path__ + "37ff1ad1f9e034739b098529ed7cac87.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard_emails_2x.png
// module id = 99
// module chunks = 0 1 2 3 4